var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmBrandmarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.9 138.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}.cls-2{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_20215a_GM_Brand_Mark_One_Color_1_21_21",
    "data-name": "20215a_GM_Brand_Mark_One_Color 1 21 21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.69,36H37.07c-6.83,0-11.34,4.56-11.34,11.34V72.81c0,6.81,4.61,11.34,11.34,11.34h8.47v2c-.11,4.91-2.92,7.76-9.68,7.89H31.59v8.88h4.27c12.55,0,19.62-5.94,19.83-16.83V36ZM45.56,75.36H40a3.93,3.93,0,0,1-4.12-4.1V48.78a3.84,3.84,0,0,1,4-4h5.7Zm67.6-28V84.15H103V48.82a3.79,3.79,0,0,0-4-4H93.33V84.15H83.21V44.78H73.49V84.15H63.37V36h38.45C108.89,36,113.16,40.37,113.16,47.34Zm0,55.61H63.37V94.06h49.79ZM138.9,19.81C138.9,7.8,131.11,0,119.08,0H19.81C7.8,0,0,7.78,0,19.81v99.32c0,12,7.78,19.81,19.81,19.81h99.27c12,0,19.82-7.78,19.82-19.81ZM118.16,130.12H20.73c-7.86,0-11.91-4-11.91-11.91V20.73c0-7.86,4-11.91,11.91-11.91h97.43c7.86,0,11.92,4,11.92,11.91v97.48C130.08,126.07,126,130.12,118.16,130.12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmBrandmarkDark);
export default __webpack_public_path__ + "static/media/gm-brandmark-dark.323ab07dbffb38eddac11cd44fccb2d8.svg";
export { ForwardRef as ReactComponent };